import { Box } from '@mui/material'
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined'
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined'
import { BoxCard, Chip, Grid, Section, Typography } from 'src/lib'
import { PLATFORMS } from './types'

interface IPlatformSectionProps {
    selectedPlatform: string | null
    onSelect: (id: string) => void
}

const PlatformSection = ({ selectedPlatform, onSelect }: IPlatformSectionProps) => (
    <Section
        icon={<CorporateFareOutlinedIcon />}
        title="Plataforma"
        subtitle="Selecione a plataforma de origem dos dados"
    >
        <Grid container gap={2}>
            {PLATFORMS.map((platform) => (
                <BoxCard
                    key={platform.id}
                    onClick={platform.available ? () => onSelect(platform.id) : undefined}
                    sx={{
                        position: 'relative',
                        width: 148,
                        minHeight: 88,
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 0.5,
                        cursor: platform.available ? 'pointer' : 'default',
                        opacity: platform.available ? 1 : 0.4,
                        transition: 'border-color 0.15s ease, background-color 0.15s ease',
                        ...(selectedPlatform === platform.id && {
                            borderColor: 'primary.main',
                            bgcolor: 'rgba(162, 205, 237, 0.06)',
                        }),
                        ...(platform.available && {
                            '&:hover': { borderColor: 'primary.main' },
                        }),
                    }}
                >
                    {!platform.available && (
                        <Box sx={{ position: 'absolute', top: 6, right: 6 }}>
                            <Chip label="Em breve" color="neutral" size="small" />
                        </Box>
                    )}
                    <Box sx={{
                        height: 40,
                        width: 112,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: platform.logo ? '#ffffff' : 'transparent',
                        borderRadius: 1,
                        px: 1,
                    }}>
                        {platform.logo
                            ? <img src={platform.logo} alt={platform.label} style={{ maxHeight: platform.id === 'open-finance' ? 96 : 32, maxWidth: platform.id === 'open-finance' ? 128 : 96, objectFit: 'contain' }} />
                            : <UploadFileOutlinedIcon sx={{ fontSize: 32, color: 'primary.main', opacity: 0.85 }} />
                        }
                    </Box>
                    <Typography variant="caption">{platform.label}</Typography>
                </BoxCard>
            ))}
        </Grid>
    </Section>
)

export { PlatformSection }